import React from 'react';
import { Page } from '@adobe/aem-react-editable-components';
import './components/MappedComponents';

function App(props) {
  return <Page {...props} />;
}

export default App;
